<template>
<div class="storyResult"
  :data-loading="isLoading"
>
  <app-loading class="storyResult__loading" :is-loading="isLoading"></app-loading>
  <div class="sh-result__top">
    <div class="sh-result__topTitle">
      <uranai-img data-clip-path-support="true" data-size="sm" size="sm" :src="packImage" :alt="item.item_name"></uranai-img>
      <h1>
        <span>{{ counselorName }}が占う</span>
        {{ itemName }}
      </h1>
    </div>
    <div v-if="menuName" class="sh-result__topSub">
      {{ menuName }}
    </div>
  </div>
  <div class="storyResult__body sh-result__middle">
    <div v-if="results.result_data[0]" class="resultContent">
      <div v-for="result in results.result_data" :key="result.menu_id">
        <p v-if="result.text1" v-html="result.text1"></p>
        <p v-if="result.text2" v-html="result.text2"></p>
        <p v-if="result.text3" v-html="result.text3"></p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import { FORMAT } from '@/CONSTS'

export default {
  name: 'story-result-second-half',
  data() {
    return {
      FORMAT,
      isLoading: false,
      errorMessage: null
    }
  },
  props: {
    itemsId: String,
    itemName: String,
    menuName: String,
    packImage: String,
    counselorId: String,
    counselorName: String,
    results: Object,
    default() {
      return {}
    },
    fortdate: String,
    postData: Object
  },
  computed: {
    ...mapState({
      counselor: state => state.counselors.counselor,
      item: state => state.item.selected
    })
  },
  mounted() {
    this.isLoading = true
    this.$store.dispatch(type.RESET_SELECTED_ITEM)
    this.$store.dispatch(type.RESET_COUNSELOR)
    this.$store
      .dispatch(type.SELECT_ITEM, { id: parseInt(this.itemsId, 10) }) // 00000nの形式で渡るのでparseIntする
      .then(this.handleSelectItemSuccess)
      .catch(this.handleSelectItemError)
      .finally(() => {
        this.isLoading = false
      })
  },
  methods: {
    handleSelectItemSuccess() {
//      this.$store.dispatch(type.GET_COUNSELOR, this.counselorId)
//      this.errorMessage = null
    },
    handleSelectItemError(error) {
      if (error) {
//        this.errorMessage = error.message
      }
    }
  }
}</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/StoryResultSecondHalf.vue